/* istanbul ignore file */
'use client';

import type { SVGProps } from 'react';
import { useTheme } from 'styled-components';

import type theme from '@shared/theme';

type Props = SVGProps<SVGSVGElement> & {
    fillColor?: keyof typeof theme.colors;
};

export default function DocumentIcon({ fillColor, ...props }: Props) {
    const theme = useTheme();

    return (
        <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="33"
            viewBox="0 0 32 33"
            {...props}
            role="img"
        >
            <path
                fill={fillColor ? theme.colors[fillColor] : '#000546'}
                d="M7.077 28.174a2.327 2.327 0 0 1-1.71-.7 2.327 2.327 0 0 1-.7-1.71V7.918c0-.673.233-1.244.7-1.71a2.327 2.327 0 0 1 1.71-.7h17.846c.674 0 1.244.233 1.71.7.467.466.7 1.037.7 1.71v17.846c0 .674-.233 1.244-.7 1.71-.466.467-1.036.7-1.71.7H7.077Zm0-2h17.846a.392.392 0 0 0 .282-.128.391.391 0 0 0 .128-.282V7.918a.392.392 0 0 0-.128-.282.392.392 0 0 0-.282-.128H7.077a.391.391 0 0 0-.282.128.391.391 0 0 0-.128.282v17.846c0 .103.043.197.128.282.085.086.18.128.282.128Zm3.59-3h6.666a.967.967 0 0 0 .713-.287.967.967 0 0 0 .287-.713.967.967 0 0 0-.287-.712.967.967 0 0 0-.713-.288h-6.666a.967.967 0 0 0-.713.288.967.967 0 0 0-.287.712c0 .284.096.522.287.713a.967.967 0 0 0 .713.287Zm0-5.333h10.666a.967.967 0 0 0 .713-.287.967.967 0 0 0 .287-.713.967.967 0 0 0-.287-.713.967.967 0 0 0-.713-.287H10.667a.967.967 0 0 0-.713.287.967.967 0 0 0-.287.713c0 .284.096.521.287.713a.967.967 0 0 0 .713.287Zm0-5.333h10.666a.967.967 0 0 0 .713-.287.967.967 0 0 0 .287-.713.967.967 0 0 0-.287-.713.967.967 0 0 0-.713-.287H10.667a.967.967 0 0 0-.713.287.967.967 0 0 0-.287.713c0 .284.096.521.287.713a.967.967 0 0 0 .713.287Z"
            />
        </svg>
    );
}
